<template>

<div align="justify">
    <!--<p class="h4" align="center">Сайт организации ООО "АИС"</p>-->
    <div align="justify" style="padding: 10px;">
        
        <h3 align="center">
        ПО DataMatrix. Продажа.
        </h3>
        
        <p>
            Программное обеспечение «Сканер Data Matrix» является платным продуктом. Стоимость поддержки – по факту выполненных работ.
        </p>
        <p>
            Доступ к дистрибутиву ПО предоставляется после оплаты. Стоимость составляет 12 т.р.
        </p>
        <p>
            Оставить запрос на приобретение программы можно по адресу электронной почты <strong style="color: blue;">office@ais-center.ru</strong> или по телефону <strong style="color: blue;">8 (8216) 76-33-06</strong>.
        </p>
        
        <p>
            Документация, содержащая описание функциональных характеристик ПО «Сканер Data Matrix» и информацию,
            необходимую для его установки и эксплуатации доступна при переходе по
            <a href="/docs/datamatrix/Описание функциональных характеристик ПО.pdf" target="_blank" rel="noopener">ссылке</a>.
        </p>
        
    </div>
    
</div>

</template>

<script>
export default {
    name: 'PageContacts',
    methods: {
        func1: function(){
            alert("+++");
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    
</style>

